import { inject } from '@angular/core';
import { signalStoreFeature, withMethods } from '@ngrx/signals';
import { ToastrService } from 'ngx-toastr';

export function withToastr(name: string) {
  return signalStoreFeature(
    withMethods((_, toastrService = inject(ToastrService)) => ({
      showSuccessToast(success: string, title?: string) {
        toastrService.success(success, title ?? name);
      },
      showErrorToast(error: string, title?: string) {
        toastrService.error(error, title ?? name);
      },
    })),
  );
}
